import { Exclude, Expose } from 'class-transformer';
import { IsNumber, ValidateNested } from 'class-validator';

import { BaseModel } from '@core/data-access';

import { FlattenObject, MyInfoAddress } from '../util';
import { MyInfoAddressNonSG, MyInfoAddressSG } from './address.model';

@Exclude()
export class CPFHousingWithdrawal extends BaseModel {
  @Expose()
  @MyInfoAddress()
  @ValidateNested()
  address!: MyInfoAddressSG | MyInfoAddressNonSG;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  accruedinterestamt!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  monthlyinstalmentamt!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  principalwithdrawalamt!: number;

  @Expose()
  @FlattenObject('value')
  @IsNumber({ allowNaN: false, allowInfinity: false })
  totalamountofcpfallowedforproperty!: number;
}
